"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.policyTypes = void 0;
exports.policyTypes = { Home: 'H', Auto: 'A', ARBundle: 'AR', HABundle: 'HA', Renters: 'R' };
//# sourceMappingURL=index.js.map